import { useLocalization } from "../../hooks/useLocalization";
import { RoutePageMeta } from "../../seo/RoutePageMeta";

type LegalPageKey = "TERMS" | "PRIVACY";

interface LegalDocumentPageProps {
  document: LegalPageKey;
}

const SEO_PAGE: Record<LegalPageKey, "TERMS" | "PRIVACY"> = {
  TERMS: "TERMS",
  PRIVACY: "PRIVACY",
};

export const LegalDocumentPage = ({ document }: LegalDocumentPageProps) => {
  const { strings } = useLocalization();
  const copy = strings.LEGAL[document];

  return (
    <div className="legal-page">
      <RoutePageMeta page={SEO_PAGE[document]} />
      <article className="legal-page-shell">
        <header className="legal-page-header">
          <h1 className="legal-page-title">{copy.TITLE}</h1>
          <p className="legal-page-updated">{copy.UPDATED}</p>
          {copy.INTRO ? <p className="legal-page-intro">{copy.INTRO}</p> : null}
        </header>

        <div className="legal-page-sections">
          {copy.SECTIONS.map((section) => (
            <section key={section.TITLE} className="legal-page-section">
              <h2 className="legal-page-section-title">{section.TITLE}</h2>
              <p className="legal-page-section-body">{section.BODY}</p>
            </section>
          ))}
        </div>
      </article>
    </div>
  );
};
